import { jsx as e } from "react/jsx-runtime";
const i = ({
  link: t
}) => {
  const r = (t.includes("/shorts/") ? t.split("/shorts/") : t.split("?v="))[1];
  return /* @__PURE__ */ e(
    "iframe",
    {
      title: r,
      width: "100%",
      height: "345",
      src: `https://www.youtube.com/embed/${r}`
    }
  );
};
export {
  i as youtubeVideoInterceptor
};
